<div class="content-wrapper-inner">
  <app-disabled-section-widget></app-disabled-section-widget>
  <div class="page-content">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div #headerWrapper class="filter-top-bar">
      <div class="filter-wrapper">
        <div class="filter-tabs-holder align-items-center">
          <div class="filter-tab">
            <a class="dropdown-toggle" role="button" [dropdown]="groupByContent">
              <i class="icon-more"></i> Group By: {{ startGroupByLabel }}
            </a>
            <ng-template #groupByContent let-dropdown="dropdown">
              <ul class="dropdown-menu dropdown-group-by px-0 py-15 rounded-15 bg-neutral-n1">
                <li class="title">
                  <h6>Select group</h6>
                </li>
                <li class="dropdown-item" (click)="setStartGroupBy(g);dropdown.hide();" *ngFor="let g of startGroupByDef">{{ g.title }} <i
                    *ngIf="startGroupBy === g.value" class="icon-check"></i></li>
              </ul>
            </ng-template>
          </div>
          <div *ngIf="demoMode !== null" class="filter-tab">
            <a class="dropdown-toggle" role="button" [dropdown]="dateContent">
              <i class="icon-calendar"></i> Date <span *ngIf="rangeLabel">({{ rangeLabel }})</span>
            </a>
            <ng-template #dateContent let-dropdown="dropdown">
              <div class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
                <div class="date-filter-drop mx-15">
                  <input-search-period (change)="onChangeDatesRange($event);dropdown.hide();" [placeholder]="'Date'" [ranges]="ranges" [start]="rangeStart"
                    [end]="rangeEnd" [autoApply]="false" [minDate]="minDate" [maxDate]="maxDate"></input-search-period>
                </div>
              </div>
            </ng-template>
          </div>
          <div *ngIf="usersShow" class="filter-tab">
            <a class="dropdown-toggle" role="button" [dropdown]="usersContent">
              <i class="icon-user"></i> Users <span *ngIf="users.length">({{ users.length }})</span>
            </a>
            <ng-template #usersContent>
              <div class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
                <div class="user-filter-drop">
                  <app-users-select
                    [multiple]="true"
                    [limit]="5"
                    [restoreSavedSearch]="false"
                    [roles]="['mainaccount']"
                    (selectUser)="addUser($event)"
                    (unSelectUser)="removeUser($event)"
                    (clear)="onClearUsers()"></app-users-select>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="filter-right-col">
        <div class="search-holder">
          <input type="search" class="form-control table-search" [formControl]="searchControl" [readOnly]="!table" />
          <span class="icon-search"></span>
        </div>
      </div>
    </div>
    <div class="table-wrapper" #tableWrapper>
      <div class="alert empty text-center" *ngIf="usersShow && !userIds.length">
        <h3 class="text-muted">Select users</h3>
      </div>
      <app-analytics-table *ngIf="demoMode !== null && userIds.length" [source]="source" [userIds]="userIds" [from]="from" [to]="to" [demoMode]="demoMode"
        [startGroupBy]="startGroupBy"></app-analytics-table>
    </div>
  </div>
</div>
